import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  token: string | null;
  orderId: string | null;
  amount?: string | null; // 👈 можно передать в URL
}

export const usePaymentScreen = ({ token, orderId, amount }: Props) => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [showResult, setShowResult] = useState(false);

  const handleSuccess = useCallback(() => {
    // Пытаемся открыть deep link
    window.location.href = `yourapp://payment/success?orderId=${orderId}`;

    setTimeout(() => {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        setShowResult(true);
      } else {
        navigate(`/orders/${orderId}`);
      }
    }, 500);
  }, [navigate, orderId]);

  const handleError = useCallback(() => {
    setError("Платеж не прошел. Пожалуйста, попробуйте снова.");
  }, []);

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return {
    error,
    showResult,
    amount,
    orderId,
    handleSuccess,
    handleError,
    handleBack,
  };
};
